<template>
  <v-container>
    <v-row>
      <v-col>
        <v-sheet class="elevation-1">
          <order-form></order-form>
          <v-dialog
            v-model="showDialog"
            persistent
            max-width="350"
          >
            <v-card>
              <v-card-title class="headline">
                Discard new order?
              </v-card-title>
              <v-card-text>Leaving the new order form will discard any infomation you have already entered.</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color=""
                  text
                  @click="cancel"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  @click="discard"
                >
                  Discard
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import OrderForm from '@/components/OrderForm'

export default {
  name: "NewOrder",
  components: {
    OrderForm
  },

  data: () => ({
    to: null,
    showDialog: false
  }),

  beforeRouteLeave(to, from, next) {
    if (!this.$store.state.orders.orderStarted) {
      next()
    } else {
      if (this.to) {
        next();
      } else {
        this.to = to;
        this.showDialog = true;
      }
    }
  },

  mounted() {
    this.updateWindowTitle({ newTitle: "New Order" });
  },
  methods: {
    ...mapActions(["updateWindowTitle"]),
    cancel() {
      this.showDialog = false;
      this.to = null;
    },
    discard() {
      this.$store.commit('orders/SET_ORDER_STARTED', false)
      this.$router.push(this.to)
    }
  },
};
</script>
